import { createAction, handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/login";

const LOGIN = "login/LOGIN"; // 로그인 정보 전송
const LOGIN_SUCCESS = "login/LOGIN_SUCCESS"; // 로그인 성공

const LOGOUT = "login/LOGOUT"; // 로그아웃
const USER_INFO = "login/USER_INFO"; // USER_INFO 저장
const WITHDROW = "login/WITHDROW"; // 회원탈퇴
const CHECK_SESSION = "login/CHECK_SESSION"; // 자바 세션체크

export const loginSubmit = createPromiseThunk(LOGIN, api.login);
export const logoutSubmit = createPromiseThunk(LOGOUT, api.logout);
export const changeUserInfo = createAction(USER_INFO);
export const withdraw = createPromiseThunk(WITHDROW, api.withdraw);
export const checkSession = createPromiseThunk(CHECK_SESSION, api.checkSession);

const initialState = {
  authorization: null,
  loginData: null
};

export default handleActions(
  {
    [LOGIN_SUCCESS]: (state, { payload }) => ({
      ...state,
      authorization: payload.data.auth
    }),
    [USER_INFO]: (state, { payload }) => ({
      ...state,
      loginData: payload
    })
  },
  initialState
);
